export default __webpack_public_path__ + "static/media/fondo.90422ed8.jpg";